import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    footList: []
  },
  mutations: {
    SET_FOOTLIST(state, data) {
      state.footList = data
    }
  },
  getters: {
    footList: state => state.footList
  }
})